import React, { Component } from "react";
import { useState } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import Fuse from "fuse.js";
import { BiSave, BiRefresh, BiUpload, BiDownload } from "react-icons/bi";
import { BsFillPencilFill, BsFillPrinterFill } from "react-icons/bs";
import { FaRegFilePdf } from "react-icons/fa6";

import {
  Nav,
  Stack,
  FormControl,
  InputGroup,
  Table,
  OverlayTrigger,
  Tooltip,
  Navbar,
} from "react-bootstrap";
import { Button, ButtonToolbar, Form, Row, Col } from "react-bootstrap";

export class RawMaterialsOutOfStock extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      selectedCategoryId: "1",
      selectedCategoryName: "All",
      rawmaterialsinventoryFiltered: [],
      rawmaterialsinventoryFilteredCopy: [],
      searchData: [],
      searchquery: "",
      reload: true,
      instockRequired: 10,
      instockRequiredMin: 0,
      instockRequiredMax: 20,
      rawmaterialcategory: [],
    };
  }

  GetPurchaseRequestHTML = () => {
    var str = "<html>";
    str += '<div style="width: 100%;text-align: center">';
    str +=
      "<h4><u>" +
      "Out-Of-Stock" +
      "</u>" +
      " [" +
      this.context.GetInDateFormat(new Date()) +
      " ]</h4>";
    str += "<h4>" + this.context.store.name + "</h4>";
    str += "</div>";

    str += '<table style="width: 100%;border:dashed;text-align:start">';
    str +=
      '<thead ><th></th><th style="text-align:start">ItemName</th><th style="text-align:start">HSNCode</th><th style="text-align:start">BatchId</th><th style="text-align:start">InStockQty</th><th style="text-align:start">Unit</th></thead>';

    var oos = this.state.rawmaterialsinventoryFiltered.filter(
      (prod) =>
        prod.instock >= Number(this.state.instockRequiredMin) &&
        prod.instock <= Number(this.state.instockRequiredMax)
    );

    oos.map((item, i) => {
      str +=
        "<tr><td>" +
        (i + 1) +
        "</td>" +
        "<td>" +
        item.name +
        "</td>" +
        "<td>" +
        item.hsnCode +
        "</td>" +
        "<td>" +
        item.batchId +
        "</td>" +
        "<td>" +
        item.instock +
        "</td>" +
        "<td>" +
        item.unit +
        "</td>" +
        "</tr>";
    });
    str += "</table></html>";

    return str;
  };
  PrintMe = (invoiceHtml) => {
    var printWindow = window.open("", "_blank");
    printWindow.document.write(this.GetPurchaseRequestHTML());
    printWindow.document.close();
    this.onPrintFinished(printWindow.print(), printWindow);
  };
  onPrintFinished = (status, printWindow) => {
    var osvar = this.getOS();
    if (osvar == "Windows") printWindow.close();
  };
  getOS = () => {
    var uA = navigator.userAgent || navigator.vendor || window.opera;
    if (
      (/iPad|iPhone|iPod/.test(uA) && !window.MSStream) ||
      (uA.includes("Mac") && "ontouchend" in document)
    )
      return "iOS";

    var i,
      os = ["Windows", "Android", "Unix", "Mac", "Linux", "BlackBerry"];
    for (i = 0; i < os.length; i++)
      if (new RegExp(os[i], "i").test(uA)) return os[i];
  };

  onCategorySelectChangeEvent = (e) => {
    this.setState({ reload: false });
    this.setState({ selectedCategoryId: e.target.value }, () => {
      this.onCategoryChanges();
    });
  };

  onRawmaterialsinventoryFilteredChanged = () => {
    this.setState({ reload: false }, () => {
      this.setState({ reload: true });
    });
  };
  onCategoryChanges = () => {
    console.log(
      "Category changes; prod length=" +
        this.state.rawmaterialsinventoryFiltered.length
    );

    //when main and sub are "All"
    if (this.state.selectedCategoryId === "0") {
      this.setState(
        {
          rawmaterialsinventoryFiltered: JSON.parse(
            JSON.stringify([...this.state.rawmaterialsinventoryFilteredCopy])
          ), //deep clone
        },
        () => this.onRawmaterialsinventoryFilteredChanged()
      );
    }
    //when Main is not "ALL" but sub is "All"
    else if (this.state.selectedCategoryId !== "0") {
      this.setState(
        {
          rawmaterialsinventoryFiltered: JSON.parse(
            JSON.stringify(
              this.state.rawmaterialsinventoryFilteredCopy.filter((prod) => {
                return prod.categoryId === this.state.selectedCategoryId;
              })
            )
          ),
        },
        () => this.onRawmaterialsinventoryFilteredChanged()
      );
    }
  };

  onSearchChange = (query) => {
    this.setState({ reload: false });
    this.setState({ searchquery: query });
    if (!query) {
      //this.setState({ searchData: [] });
      this.setState(
        {
          rawmaterialsinventoryFiltered:
            this.state.rawmaterialsinventoryFilteredCopy,
        },
        () => {
          this.setState({ reload: true });
        }
      );
      return;
    }
    const fuse = new Fuse(this.state.rawmaterialsinventoryFiltered, {
      keys: ["name"],
      threshold: 0.6,
    });
    const result = fuse.search(query);
    const finalResult = [];
    if (result.length) {
      result.forEach((item) => {
        finalResult.push(item.item);
      });
      this.setState(
        { rawmaterialsinventoryFiltered: finalResult.slice(0, 15) },
        () => {
          this.setState({ reload: true });
        }
      );
    } else {
      this.setState({ rawmaterialsinventoryFiltered: [] });
    }
  };
  OnRefreshButtonClick = () => {
    this.setState({ reload: false }, () => {
      this.onCategoryChanges();
    });
  };
  useForceUpdate = () => {
    const [value, setValue] = useState(0); // integer state
    return () =>
      setValue(
        (value) => value + 1,
        () => {}
      ); // update the state to force render
  };

  OnInstockRequiredChanged = (e) => {};

  GetRawMaterialCategories = () => {
    fetch(
      process.env.REACT_APP_API +
        "Rawmaterials/GetRawMaterialCategories/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ rawmaterialcategory: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  GetRawMaterialsInventories = () => {
    fetch(
      process.env.REACT_APP_API +
        "Rawmaterials/GetRawMaterialsInventories/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({
            rawmaterialsinventoryFiltered: data,
          });
          this.setState({ rawmaterialsinventoryFiltered: data }, () => {
            this.setState({ rawmaterialsinventoryFilteredCopy: data });
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  componentDidMount() {
    if (this.state.firstLoad == undefined) {
      this.state.firstLoad = true;
      this.GetRawMaterialCategories();
      this.GetRawMaterialsInventories();
    }
    window.scrollTo(0, 0);
  }

  componentDidUpdate() {}

  render() {
    return (
      <>
        <div className="Container-fluid mx-0 p-0 pagebackground">
          <div className="Container-fluid m-0 p-0 text-white ">
            <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
              <h3>
                <b>Rawmaterials InStock Checker</b> &nbsp;
              </h3>
            </Navbar>
            <div className="purposestyle">
              {" "}
              <b>Purpose:</b> Use this Module to find items which are between
              Instock Range. Use "Minimum & Maximum In-Stock range" to find
              results.
            </div>
            <div className=" p-3 ">
              {/* Responsive filter row: 3 columns on md+, stacked on xs */}
              {/* --- Compact single-row filters using TABLE (labels kept, narrow controls) --- */}
              <Table
                className={window.innerWidth > 900 ? "w-50" : "w-100"}
                size="sm"
                responsive="true"
                style={{ marginBottom: 8 }}
              >
                <tbody>
                  <tr>
                    {/* MIN */}
                    <td
                      style={{
                        width: "33%",
                        verticalAlign: "top",
                        padding: "6px 8px",
                      }}
                    >
                      <div
                        className="small text-secondary"
                        style={{ marginBottom: 6 }}
                      >
                        Enter minimum In-Stock:
                      </div>
                      <div>
                        <Form.Control
                          type="number"
                          size="sm"
                          min={0}
                          name="instockRequiredMin"
                          value={this.state.instockRequiredMin}
                          required
                          className="text-center"
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => {
                            this.setState({
                              instockRequiredMin: e.target.value,
                            });
                          }}
                          style={{
                            width: 100,
                            maxWidth: "100%",
                            height: 34,
                            padding: "6px 8px",
                            fontSize: 13,
                          }}
                        />
                      </div>
                    </td>

                    {/* MAX */}
                    <td
                      style={{
                        width: "33%",
                        verticalAlign: "top",
                        padding: "6px 8px",
                      }}
                    >
                      <div
                        className="small text-secondary"
                        style={{ marginBottom: 6 }}
                      >
                        Enter maximum In-Stock:
                      </div>
                      <div>
                        <Form.Control
                          type="number"
                          size="sm"
                          min={0}
                          name="instockRequiredMax"
                          value={this.state.instockRequiredMax}
                          required
                          className="text-center"
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => {
                            this.setState({
                              instockRequiredMax: e.target.value,
                            });
                          }}
                          style={{
                            width: 100,
                            maxWidth: "100%",
                            height: 34,
                            padding: "6px 8px",
                            fontSize: 13,
                          }}
                        />
                      </div>
                    </td>

                    {/* CATEGORY */}
                    <td
                      style={{
                        width: "34%",
                        verticalAlign: "top",
                        padding: "6px 8px",
                      }}
                    >
                      <div
                        className="small text-secondary"
                        style={{ marginBottom: 6 }}
                      >
                        Main Category
                      </div>
                      <div>
                        <Form.Select
                          size="sm"
                          value={this.state.selectedCategoryId}
                          onChange={(e) => {
                            this.onCategorySelectChangeEvent(e);
                          }}
                          style={{
                            width: 160,
                            maxWidth: "100%",
                            height: 34,
                            fontSize: 13,
                          }}
                        >
                          <option value={0}>ALL</option>
                          {this.state.rawmaterialcategory.map((category) => (
                            <option key={category.id} value={category.id}>
                              {category.name}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>

              <Table className="p-0 m-0" size="sm">
                <Row className="">
                  <Col>
                    <Stack direction="horizontal" gap={3} className="">
                      <b>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          class="bi bi-search"
                          viewBox="0 0 16 16"
                        >
                          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                        </svg>
                      </b>
                      <FormControl
                        type="search"
                        placeholder="Search... "
                        className="text-primary fw-bold bg-white "
                        size="lg"
                        aria-label="Search"
                        onChange={(e) => this.onSearchChange(e.target.value)}
                      />
                    </Stack>
                  </Col>
                </Row>
              </Table>
            </div>
            <div className="text-center p-3 w-100 text-black">
              <Row>
                <Col className="text-start">
                  <h3>Results</h3>
                </Col>
                <Col className="text-end">
                  {this.state.rawmaterialsinventoryFiltered.length > 0 ? (
                    <>
                      <Button onClick={this.PrintMe} className="rounded-3">
                        <FaRegFilePdf size={20} />
                        &nbsp;&nbsp;PDF / Print&nbsp;&nbsp;
                        <BsFillPrinterFill size={20}></BsFillPrinterFill>
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>

              <Table border striped className=" px-0">
                <thead className="text-start">
                  <tr className="text-center text-black bg-white border">
                    <th width="5%"></th>
                    <th className="text-start" width="35%">
                      Name
                    </th>
                    <th width="20%">Category</th>
                    <th width="10%">Last Purchased Price</th>
                    <th width="10%">In-Stock Qty/WT</th>
                    <th width="10%">Unit </th>
                  </tr>
                </thead>

                <tbody className="text-primary border">
                  {this.state.rawmaterialsinventoryFiltered.map((prod, i) => (
                    <>
                      {prod.instock >= Number(this.state.instockRequiredMin) &&
                      prod.instock <= Number(this.state.instockRequiredMax) &&
                      this.state.reload == true ? (
                        <ShowOutOfStockRawmaterialsInline
                          index={i}
                          prod={prod}
                          Categories={this.state.rawmaterialcategory}
                        ></ShowOutOfStockRawmaterialsInline>
                      ) : (
                        <></>
                      )}
                    </>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export class ShowOutOfStockRawmaterialsInline extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      prod: this.props.prod,
    };
  }

  componentDidMount() {}

  getCategoryName = (id) => {
    var result = this.props.Categories.filter(
      (e) => e.id === this.state.prod.categoryId
    );

    if (result.length === 0) {
      return "Unknown Category";
    }
    return result[0].name;
  };

  render() {
    return (
      <>
        <tr
          className="text-center text-secondary bg-white mx-5"
          style={{ fontSize: "12px" }}
        >
          <td>{this.props.index}</td>
          <td className="text-start">{this.state.prod.name}</td>
          <td>{this.getCategoryName(this.state.prod.categoryId)}</td>
          <td>{this.state.prod.purchasePrice}</td>

          <td>
            <h3 className="text-center">
              {this.state.prod.instock.toFixed(0)}
            </h3>
          </td>
          <td>{this.state.prod.unit}</td>
        </tr>
      </>
    );
  }
}
